<template>
  <div style="display: block; padding-top: 70px">
    <img src="../assets/warning.png" class="globall">
    <h1>NO INVOICE NUMBER</h1>
    <h1 style="padding-left: 70px">DETECTED!</h1>
  </div>
</template>

<script>
export default {
  name: 'ErrorPage'
}
</script>

<style>
.globall {
  height: 300px;
  width: 300px;
}
</style>